import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import InputGroup from '../../../../../components/global/InputGroup';
import { getAsset } from '../../../../../util/assets';
import Alert from '../../../../../components/global/Alert';
import Button from '../../../../../components/global/Button';
import Spinner from '../../../../../components/global/Spinner';
import { canRequestMagicLink } from '../../../../../util/product-permissions';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  isFormValid: PropTypes.bool,
  onSendMagicLink: PropTypes.func.isRequired,
};

const AuthModeEmail = ({
  onSubmit,
  values,
  onChange,
  error,
  loading,
  isFormValid,
  onSendMagicLink,
}) => {
  return (
    <Fragment>
      <form className="login-form" onSubmit={onSubmit}>
        <InputGroup
          id="email"
          type="email"
          name="email"
          addon={<img alt="" src={getAsset('/shutterbug/icons/email.svg')} />}
          placeholder="Your email address"
          value={values.email}
          onChange={({ target }) => onChange('email', target.value)}
          wrapperClassName="mb-1"
        />

        {error && (
          <Alert type="danger" className="mt-2">
            <strong>Signing in wasn&apos;t successful</strong>
            <br />
            {error}
          </Alert>
        )}
        <div className="text-center">
          <Button
            type="submit"
            className="mt-4 mb-1 login-email-form-button"
            disabled={loading || !isFormValid}
            data-testId="sign-in-button"
          >
            {!loading ? 'Continue' : <Spinner light size="xs" />}
          </Button>
        </div>
      </form>
      {canRequestMagicLink() && (
        <Fragment>
          <div className="email-link-header">Magic Link</div>
          <p>
            We can email you a magic link so you can sign in without having to
            type your password.
          </p>
          <Button
            onClick={onSendMagicLink}
            btnStyle="link"
            className="text-bold"
          >
            Email me a magic link
          </Button>
        </Fragment>
      )}
    </Fragment>
  );
};

AuthModeEmail.propTypes = propTypes;

export default AuthModeEmail;
